import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import VisualizadorImagenes from "./visualizadorImagenes/visualizadorImagenes";
import SelectorCantidad from "../Common/selectorCantidad/selectorCantidad";
import VisualizadorPrecio from "./visualizadorPrecio/visualizadorPrecio";
import ArticuloAlternativa from "./articuloAlternativa/articuloAlternativa";
import Button from "@material-ui/core/Button";
import "./style.css";
import "react-image-gallery/styles/css/image-gallery.css";
import { Row, Col } from "react-flexbox-grid";
import { getConfigVidriera } from '../../sagas/ConfigGlobalSaga/calls';
import ImageModal from "../UI/Modals/ImageModal";
import { useEffect, useState } from "react";

const styles = (theme) => ({});


const NombreArticuloTooltip = withStyles((theme) => ({
  tooltip: {
    background: "#000000 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "4px",
    padding: "0px",
    opacity: "1 !important",
    margin: "7px 0 4px 25px !important",
  },
}))(Tooltip);

const ArticuloItem = ({
  cantidadInicial,
  agregarQuitarUnidad,
  item,
  pedido,
  srcImgOferta,
  usuario = {},
}) => {
  const [configVidriera, setConfigVidriera] = useState(null);
  const [cantidadPedido, setCantidadPedido] = useState({
    cantidad: cantidadInicial,
    alternativa: null,
  });
  const [showAlternativas, setShowAlternativas] = useState(false);
  const [cantidadInicialAlternativas, setCantidadInicialAlternativas] = useState(0);
  const [timerId, setTimerId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [imagenModal, setImagenModal] = useState(null);

  useEffect(() => {
    if (cantidadPedido !== cantidadInicial) {
      setCantidadPedido({ cantidad: cantidadInicial, alternativa: null });
    }
  }, [cantidadInicial]);

  useEffect(() => {
    const checkAndRedirect = async () => {
      try {
        const data = await getConfigVidriera();
        setConfigVidriera(data);
        if (data === "0" && !usuario.id) {
          window.location.hash = "/Login";
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error al obtener configVidriera:", error);
        setIsLoading(false);
      }
    };

    checkAndRedirect();
  }, [usuario.id]);

  const onAgregarQuitarCantidad = (cantidad, alternativa) => {
    setShowAlternativas(false);
    setCantidadPedido({ cantidad, alternativa });

    if (timerId) {
      clearTimeout(timerId);
    }

    const newTimerId = setTimeout(() => {
      agregarQuitarUnidad(cantidad, item, alternativa);
    }, 1500);

    setTimerId(newTimerId);
  };

  const showPrice = () => {
    if (configVidriera === "2" || configVidriera === 2) {
      return (
        item.catalogoEntradaActivo && (
          <VisualizadorPrecio
            precioLista={item.precioLista}
            porcentajeDescuentoFullCatalogo={
              usuario ? usuario.porcentajeDescuentoFullCatalogo : null
            }
          />
        )
      );
    } else if (configVidriera === "1" || configVidriera === 1) {
      if (!usuario.id) {
        return null;
      } else {
        return (
          item.catalogoEntradaActivo && (
            <VisualizadorPrecio
              precioLista={item.precioLista}
              porcentajeDescuentoFullCatalogo={
                usuario.porcentajeDescuentoFullCatalogo
              }
            />
          )
        );
      }
    } else {
      return (
        item.catalogoEntradaActivo && usuario && (
          <VisualizadorPrecio
            precioLista={item.precioLista}
            porcentajeDescuentoFullCatalogo={
              usuario.porcentajeDescuentoFullCatalogo
            }
          />
        )
      );
    }
  };

  const onChangeCantidad = (cantidad) => {
    if (configVidriera === "2" || configVidriera === 2 || configVidriera === "1" || configVidriera === 1) {
      if (!usuario.id) {
        window.location.hash = "/Login";
        return;
      }
    }

    let detallePedidoArticulo;
    let alternativa;
    if (pedido) {
      detallePedidoArticulo = pedido.listaPedidoDetalle.find(
        (x) => x.idArticulo === item.idArticulo
      );
      if (detallePedidoArticulo) {
        alternativa = detallePedidoArticulo.alternativa;
      }
    }

    const articuloTieneAlternativas = item.articuloAlternativas && item.articuloAlternativas.length > 0;
    const mostrarAlternativas = articuloTieneAlternativas && !detallePedidoArticulo;

    if (mostrarAlternativas) {
      setShowAlternativas(true);
      setCantidadInicialAlternativas(cantidad);
    } else {
      onAgregarQuitarCantidad(cantidad, alternativa);
    }
  };

  const openModal = (imagen) => {
    setImagenModal(imagen);
    setModalAbierto(true);
  };

  const closeModal = () => {
    setModalAbierto(false);
    setImagenModal(null);
  };

  if (isLoading) {
    return null;
  }
  return (
    <div className="articulos">
      <Card className={`card ${!usuario.id ? "cardNoLogin" : ""}`} style={{ position: "relative" }}>
        {(usuario.id ||configVidriera !== "1") && item.promoPorCantidad.length > 0 && (
          <ExpansionPanel className="ofertaCantidad">
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
              className="titleOferta"
            >
              <div style={{ margin: "auto" }}>OFERTA X CANTIDAD</div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className="contentOferta">
              <div style={{ margin: "5px", width: "100%" }}>
                <div style={{ fontSize: "14px", fontWeight: 700 }}>
                  Comprando:
                </div>
                <div style={{ fontSize: "14px", fontWeight: 400 }}>
                  {item.promoPorCantidad.map((promo) => {
                    return (
                      <Row style={{ margin: "0px" }}>
                        <Col xs={9} style={{ padding: "0px" }}>
                          <div>
                            <ul style={{ margin: "0px" }}>
                              <li>{promo.cantidad} o más</li>
                            </ul>
                          </div>
                        </Col>
                        <Col xs={3} style={{ padding: "0px", fontWeight: 700 }}>
                          <div>
                            ${promo.precioUnitarioConDescuento.toFixed(2)}
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
                </div>
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )}

        <div style={{ position: "absolute", top: 0, left: 0 }}>
          <div className="cardImgContainer">
            {/* IMAGEN ARTICULO */}
            <VisualizadorImagenes item={item} onImageClick={openModal} />
          </div>

          {/* NOMBRE ARTICULO */}{item.nombre.length > 50 ? (
            <NombreArticuloTooltip
              TransitionComponent={Zoom}
              placement="bottom-end"
              style={{ opacity: "1" }}
              enterTouchDelay={10}
              title={
                <div className="containerTooltipNombreAritulo">
                  {item.codigoBarra ? `${item.codigoBarra} - ${item.nombre}` : item.nombre}
                </div>
              }
            >
              <div className="nombreArticulo">
                {item.codigoBarra ? `${item.codigoBarra} - ${item.nombre}` : item.nombre}
              </div>
            </NombreArticuloTooltip>
          ) : (
            <div className="nombreArticulo">
              {item.codigoBarra ? `${item.codigoBarra} - ${item.nombre}` : item.nombre}
            </div>
          )}

          {showPrice()}
          {/* SELECTOR DE CANTIDAD */}

          {configVidriera === "1" && (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {!usuario.id && (
                <Button
                  className="infoPrice"
                  variant="outlined"
                  color="secondary"
                  onClick={() => { window.location.hash = "/Login"; }}
                >
                  VER PRECIO
                </Button>
              )}
            </div>
          )}


          {

            <div
              className={`rowButton ${item.catalogoEntradaActivo === false ? "rowButtonFav" : ""
                } `}
            >

              {item.catalogoEntradaActivo ? (
                <SelectorCantidad
                  value={cantidadPedido.cantidad}
                  onChange={onChangeCantidad}
                  incremento={item.incremento}
                  productoPesable={item.productoPesable}
                  cantidadLimMin={item.cantidadLimMin}
                  cantidadLimMax={item.cantidadLimMax}
                />
              ) : (
                <div className="noStock">SIN STOCK</div>
              )}
            </div>

          }
        </div>
      </Card>

      {/* MODAL DE ALTERNATIVAS DE ARTICULO */}
      {showAlternativas && (
        <ArticuloAlternativa
          open={showAlternativas}
          item={{ ...item, srcImgOferta: srcImgOferta }}
          initialValue={cantidadInicialAlternativas}
          onClose={() => setShowAlternativas(false)}
          onConfirm={onAgregarQuitarCantidad}
        />
      )}

      {/* MODAL DE IMAGEN */}
      <ImageModal
        open={modalAbierto}
        onClose={closeModal}
        imgSrc={imagenModal}
      />
    </div>
  );
};

export default withStyles(styles)(ArticuloItem);
